import React from 'react';
import classNames from 'classnames';
import metaBadge from 'assets/meta-badge.svg';
import securityBadge from 'assets/signup-security-badge.svg';

import css from './Badges.module.css';
import { LeaderBadge } from './LeaderBadge';

type Props = {
  className?: string;
  isSignUp?: boolean;
};

export const Badges = ({ className, isSignUp }: Props) => {
  return (
    <div className={classNames(className, css.badges)}>
      <div className={isSignUp ? css.badgeWrapper : css.badgeWrapperNonSignUp}>
        <LeaderBadge />
      </div>
      <div className={isSignUp ? css.badgeWrapper : css.badgeWrapperNonSignUp}>
        <img
          src={metaBadge}
          className={css.meta}
          alt="Meta Business Partner Badge"
        />
      </div>
      {isSignUp && (
        <div className={css.leftBadgeContainer}>
          <img className={css.securityBadge} src={securityBadge} />
          <div className={css.labelsContainer}>
            <div className={css.boldLabel}>14-day Free Trial</div>
            <div className={css.label}>No credit card required</div>
          </div>
        </div>
      )}
    </div>
  );
};
